import {
  GET_PRODUCT_SELECTION_LIST,
  GET_PRODUCT_SELECTION_LIST_ERROR,
  GET_PRODUCT_SELECTION_LIST_SUCCESS,
  GET_NEW_ADDONS_LIST,
  GET_NEW_ADDONS_LIST_SUCCESS,
  GET_NEW_ADDONS_LIST_ERROR,
  RESET_PRODUCT_SELECTION_ADD_TO_CART
} from '../actionTypes';

const intialData = {
  productSelectionData: {},
  addonsData: {},
  isLoading: true,
  Error: null
};

export default function ProductSelectionListReducer(
  state = intialData,
  action
) {
  switch (action.type) {
    case GET_PRODUCT_SELECTION_LIST: {
      return {
        ...state,
        ...intialData
      };
    }

    case GET_PRODUCT_SELECTION_LIST_SUCCESS: {
      return {
        ...state,
        productSelectionData: action.payload,
        Error: null
      };
    }

    case GET_PRODUCT_SELECTION_LIST_ERROR: {
      return {
        ...state,
        Error: action.payload,
        productSelectionData: {}
      };
    }

    case GET_NEW_ADDONS_LIST: {
      return {
        ...state,
        addonsData: {},
        Error: null
      };
    }

    case GET_NEW_ADDONS_LIST_SUCCESS: {
      return {
        ...state,
        addonsData: action.payload,
        Error: null,
        isLoading: false
      };
    }

    case RESET_PRODUCT_SELECTION_ADD_TO_CART: {
      return { ...intialData };
    }

    case GET_NEW_ADDONS_LIST_ERROR: {
      return {
        ...state,
        addonsData: {},
        Error: action.payload,
        isLoading: false
      };
    }

    default: {
      return { ...state };
    }
  }
}
